import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import { spEsri } from '../../globals.js'
export default {
  methods: {
    async getFeatureLayer (url) {
      // check privileges
      const roles = this.$store.getters.getRoles
      let visible = false
      for (const role of roles) {
        for (const privilege of role.privileges) {
          if (url.includes(privilege.url)) {
            if (privilege.alllayers) {
              visible = true
              break
            } else {
              const layersArr = privilege.layers.replace('[', '').replace(']', '').split(',')
              const layerId = url.split('Server/')[1]
              if (layersArr.includes(layerId)) {
                visible = true
                break
              }
            }
          }
        }
      }
      if (!visible) {
        return null
      }
      url = url.replace('SceneServer', 'FeatureServer')

      if (spEsri.sublayers[url]) {
        return spEsri.sublayers[url]
      }
      try {
        const sublayer = new FeatureLayer({ url: url })
        await sublayer.load()
        spEsri.addSublayer(url, sublayer)
        return sublayer
      } catch (error) {
        console.error(error)
        return null
      }
    },
  },
}
